import { SUPPORTED_LOCALES_OBJ } from '@zep-us/i18n';
import { type GetStaticPropsContext, type NextPageWithLayout } from 'next';
import { getEmptyLayout } from '@/layout';
import { getDefaultStaticProps } from '@/utils/next';
import { NewBoardPageView } from './NewBoardPageView';
const NewBoardPage: NextPageWithLayout = () => {
  return <NewBoardPageView data-sentry-element="NewBoardPageView" data-sentry-component="NewBoardPage" data-sentry-source-file="index.page.tsx" />;
};
NewBoardPage.getLayout = function (page) {
  return getEmptyLayout(page);
};
export default NewBoardPage;
export const getStaticProps = async ({
  locale = SUPPORTED_LOCALES_OBJ.en
}: GetStaticPropsContext) => {
  return getDefaultStaticProps({
    locale,
    namespaces: ['common', 'board', 'boardTemplates']
  });
};